import { render, staticRenderFns } from "./goodsEvaluate.vue?vue&type=template&id=4952d9b6&scoped=true&"
import script from "./goodsEvaluate.vue?vue&type=script&lang=js&"
export * from "./goodsEvaluate.vue?vue&type=script&lang=js&"
import style0 from "./goodsEvaluate.vue?vue&type=style&index=0&id=4952d9b6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4952d9b6",
  null
  
)

export default component.exports